import { getCategoryDataFromLabel } from "../helpers/zoneFilters";

import { SeatsIOSeat } from "~components/reservation/constants";
import { EventMultiBuyPromotion, EventQuery } from "~graphql/sdk";
import { getActivePromotions } from "../helpers/getActivePromotions";
import { getPrice } from "../helpers/pricing";
import { Release } from "../types";
interface SeatPropertiesProps {
  seats: SeatsIOSeat[];
  multiBuyPromotions: EventQuery["event"]["multiBuyPromotions"];
  eventTicketTypes: EventQuery["event"]["ticketTypes"];
  releasedZones: Release["releaseZones"];
}

export const addPropertiesToSeats = ({
  seats,
  multiBuyPromotions,
  eventTicketTypes,
  releasedZones,
}: SeatPropertiesProps) => {
  const activePromotions = getActivePromotions(
    multiBuyPromotions,
    seats
  ) as EventMultiBuyPromotion;

  const addTicketType = (seat: SeatsIOSeat, idx: number) => {
    const { zone: zoneName } = getCategoryDataFromLabel(seat.category?.label);

    const releasedZone = releasedZones.find(
      ({ zone }) => zone.name === zoneName
    );

    // If seat already has aticket type then leave as is
    if (seat.ticketType) {
      return seat;
    }

    const releasedTickets = releasedZone.ticketTypes
      .filter((ticket) => ticket.isActive)
      .map((ticket) => {
        return eventTicketTypes.find(
          (eventTicket) => eventTicket.id === ticket.ticketTypeId
        );
      });

    const adultTicketType = releasedTickets.find((ticketType) => {
      // const eventTicket = eventTicketTypes.find(ticket => ticket.id === ticketType.ticketTypeId);
      // console.log({ eventTicket, ticketType, eventTicketTypes})

      return ticketType.name.toLowerCase().includes("adult");
    });

    const customId: string | undefined =
      seat.objectType === "GeneralAdmissionArea"
        ? `${seat.id}-${idx}`
        : undefined;

    // Default the selected seats to Adult ticket type
    // if exists, otherwise use the first option
    const ticketType = adultTicketType || releasedTickets[0];

    return {
      ...seat,
      customId,
      ticketType,
    };
  };

  const addPrice = (seat: SeatsIOSeat) => {
    const price = getPrice({
      seat,
      type: "event",
      activePromotions,
      releasedZones,
    });

    return {
      ...seat,
      price,
    };
  };

  const addLocationLabel = (seat: SeatsIOSeat) => {
    const categoryLabel = seat.category?.label;

    const { zone: zoneLabel, section: sectionLabel } = getCategoryDataFromLabel(
      categoryLabel
    );

    return {
      ...seat,
      zoneLabel,
      sectionLabel,
    };
  };

  return seats.map(addTicketType).map(addPrice).map(addLocationLabel);
};
